// extracted by mini-css-extract-plugin
export default {"baseLabel":"BaseLabel_baseLabel__Q6B5e","baseLabel__wrapper":"BaseLabel_baseLabel__wrapper__vwzYD"};